import { ipayNet, newServer } from 'constants/constants';
import { refactorImgUrl } from './refactor-img-url';

export const uploadImage = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error('No file provided'));
      return;
    }

    const reader = new FileReader();

    reader.onloadend = async function () {
      const base64String = (reader as any)?.result?.replace('data:', '').replace(/^.+,/, '');

      const bodyObject = {
        image: `data:${file.type};base64,${base64String}`,
      };

      try {
        const response = await fetch(`${newServer}aws/post-identification-request/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': ipayNet.apiToken,
          },
          body: JSON.stringify(bodyObject),
        });

        const responseText = await response.text();
        let data: any = {};
        try {
          data = responseText ? JSON.parse(responseText) : {};
        } catch (_error) {
          throw new Error(responseText || `Upload failed (${response.status})`);
        }

        if (!response.ok) {
          throw new Error(
            data?.message || data?.info?.message || `Upload failed (${response.status})`
          );
        }

        if (!data?.key) {
          reject(new Error('Failed to upload image'));
          return;
        }

        resolve(refactorImgUrl(data.key));
      } catch (error) {
        const message = error instanceof Error ? error.message : String(error);
        reject(new Error(`Failed to upload document: ${message}`));
      }
    };

    reader.onerror = () => {
      reject(new Error('Failed to read the file'));
    };

    reader.readAsDataURL(file);
  });
};
